import Skeleton from "react-loading-skeleton";
import "./ProductCardSkeleton.css";

const ProductCardSkeleton = () => (
  <article className="product-card-skeleton" aria-hidden="true">
    <div className="product-card-skeleton__media">
      <Skeleton height="100%" borderRadius={0} />
    </div>
    <div className="product-card-skeleton__body">
      <Skeleton height={14} width="92%" borderRadius={6} />
      <Skeleton height={14} width="68%" borderRadius={6} />
      <Skeleton height={20} width="48%" borderRadius={6} />
      <Skeleton height={38} width="100%" borderRadius={8} />
    </div>
  </article>
);

export default ProductCardSkeleton;
